module.exports = __webpack_public_path__ + "media/images/header_pay_now-9e9c65f0.jpg";